const EXCLUDED_PROTOCOLS = ['mailto', 'tel', 'file', 'ftp', 'ftps'];
const appendProtocol = (url?: string, replaceWithProtocol = 'https://') => {
  if (!url || typeof url !== 'string') {
    return url;
  }

  if (url.startsWith('#') || url.startsWith('{{')) {
    return url;
  }

  const protocol = url.split(':')[0];

  if (EXCLUDED_PROTOCOLS.includes(protocol)) {
    return url;
  }

  // Some urls in a post were stored with a protocol like `https://#` which is not valid.
  // We need to replace it with just `#` to make it a valid anchor link.
  // This is a workaround for a bug in the post editor.
  if (url.match(/^https?:\/\/#/)) {
    return url.replace(/^https?:\/\/#/, '#');
  }

  // allow protocol relative links(starting with '//') & links with http(s?)://
  if (url.startsWith('http://') || url.startsWith('https://') || url.startsWith('//')) {
    return url;
  }

  return `${replaceWithProtocol}${url}`;
};

const isAnchorLink = (url: string) => {
  if (!url || typeof url !== 'string') {
    return false;
  }
  return url.startsWith('#') || url.match(/^https?:\/\/#/);
};

const isMailToLink = (url: string) => {
  if (!url || typeof url !== 'string') {
    return false;
  }
  return url.startsWith('mailto:');
};

const isTelLink = (url: string) => {
  if (!url || typeof url !== 'string') {
    return false;
  }
  return url.startsWith('tel:');
};

export { appendProtocol, isAnchorLink, isMailToLink, isTelLink };
